import { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import Swal from "sweetalert2";
import LoadingButton from "../../../../components/Loading/LoadingButton";
import { postRequestByAuth } from "../../../../function/helper";

function ComplainForm() {
  const [formSupport, setFormSupport] = useState({
    name: "",
    family: "",
    subject: "",
    message: "",
    mobile: "",
  });

  const [loading, setLoading] = useState(false);

  const [errorsSupport, setErrorsSupport] = useState({});

  const setFieldSupport = (field, value) => {
    setFormSupport({ ...formSupport, [field]: value });
    if (errorsSupport[field]) {
      setErrorsSupport({ ...errorsSupport, [field]: null });
    }
  };

  const findErrorsSupport = () => {
    const { name, family, mobile, subject, message } = formSupport;
    const newErrors = {};

    if (!name) {
      newErrors.name = "نام الزامی است";
    }
    if (!family) {
      newErrors.family = "نام خانوادگی الزامی است";
    }
    if (!mobile) {
      newErrors.mobile = "موبایل الزامی است";
    }
    if (!subject) {
      newErrors.subject = "موضوع انتقاد مشخص نشده است";
    }
    if (!message) {
      newErrors.message = "شرح تیکت مشخص نشده است";
    }

    return newErrors;
  };

  const supportRequest = async () => {
    setLoading(true);
    const response = await postRequestByAuth(
      "/setting/v1/complain/add",
      formSupport
    );
    setLoading(false);

    if (response && response.status === 200) {
      Swal.fire({
        icon: "success",
        text: response.data.message,
        showConfirmButton: true,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "green",
      });

      setFormSupport({
        name: "",
        family: "",
        subject: "",
        message: "",
        mobile: "",
      });
    } else {
      Swal.fire({
        icon: "error",
        text: response?.data?.message ?? "عملیت با خطا مواجه شد",
        showConfirmButton: true,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "gray",
      });
    }
  };

  const handleSupport = e => {
    e.preventDefault();
    const newError = findErrorsSupport();
    if (Object.keys(newError).length > 0) {
      setErrorsSupport(newError);
    } else {
      supportRequest();
    }
  };

  return (
    <div className="mt-1" dir="rtl">
      <Form onSubmit={handleSupport}>
        <Row>
          <Col lg={4} md={4} sm={12} xs={12}>
            <Form.Label>نام:</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={formSupport.name}
              onChange={e => setFieldSupport("name", e.target.value)}
              isInvalid={!!errorsSupport.name}
            />
            <Form.Control.Feedback type="invalid">
              {errorsSupport.name}
            </Form.Control.Feedback>
          </Col>
          <Col lg={4} md={4} sm={12} xs={12}>
            <Form.Label>نام خانوادگی:</Form.Label>
            <Form.Control
              type="text"
              name="family"
              value={formSupport.family}
              onChange={e => setFieldSupport("family", e.target.value)}
              isInvalid={!!errorsSupport.family}
            />
            <Form.Control.Feedback type="invalid">
              {errorsSupport.family}
            </Form.Control.Feedback>
          </Col>
          <Col lg={4} md={4} sm={12} xs={12}>
            <Form.Label>موبایل:</Form.Label>
            <Form.Control
              type="text"
              name="mobile"
              value={formSupport.mobile}
              onChange={e => setFieldSupport("mobile", e.target.value)}
              isInvalid={!!errorsSupport.mobile}
            />
            <Form.Control.Feedback type="invalid">
              {errorsSupport.mobile}
            </Form.Control.Feedback>
          </Col>
        </Row>
        <Form.Group>
          <Row>
            <Col>
              <Form.Label>موضوع:</Form.Label>
              <Form.Control
                type="text"
                name="subject"
                value={formSupport.subject}
                onChange={e => setFieldSupport("subject", e.target.value)}
                isInvalid={!!errorsSupport.subject}
              />
              <Form.Control.Feedback type="invalid">
                {errorsSupport.subject}
              </Form.Control.Feedback>
            </Col>
          </Row>
          <Form.Label>شرح:</Form.Label>
          <Form.Control
            as="textarea"
            type="text"
            name="message"
            className="form-control"
            maxLength={2000}
            onChange={e => setFieldSupport("message", e.target.value)}
            value={formSupport.message}
            isInvalid={!!errorsSupport.message}
          />
          <small className="text-secondary">حداکثر 2000 کاراکتر</small>
          <Form.Control.Feedback type="invalid">
            {errorsSupport.message}
          </Form.Control.Feedback>
        </Form.Group>
        <div className="d-flex align-items-center justify-content-center mt-4">
          {loading && (
            <LoadingButton className="btn-success-style" title="در حال ثبت" />
          )}
          {!loading && (
            <button type="submit" className="btn-success-style">
              ارسال
            </button>
          )}
        </div>
      </Form>
    </div>
  );
}

export default ComplainForm;
